import React from 'react'
import { Link } from 'lucide-react'
import { testIds } from '@/lib/test-ids'
import { parseUpdateWorkSpecSeedPrompt } from '@/lib/update-work-spec-prompt-display'

function SeedUrlChip({ href }: { href: string }) {
  let display = href
  try {
    const u = new URL(href)
    display = u.hostname + (u.pathname !== '/' ? u.pathname : '')
  } catch {
    /* use href */
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      title={href}
      className="inline-flex max-w-full min-w-0 items-center gap-1 px-1.5 py-0.5 rounded-md text-xs border transition-colors bg-background/60 text-muted-foreground border-border hover:bg-muted hover:text-foreground align-middle no-underline"
    >
      <Link className="w-3 h-3 shrink-0" />
      <span className="min-w-0 truncate">{display}</span>
    </a>
  )
}

export function UpdateWorkSpecSeedCard({ content }: { content: string }) {
  const summary = parseUpdateWorkSpecSeedPrompt(content)

  return (
    <div
      className="flex min-w-0 flex-col gap-1"
      data-testid={testIds.chatPane.updateWorkSpecSeed}
    >
      <div className="text-sm font-medium leading-snug">Update work spec</div>
      <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
        {summary?.todoUrl ? <SeedUrlChip href={summary.todoUrl} /> : null}
        {summary?.todoId ? <span className="tabular-nums">Todo {summary.todoId}</span> : null}
      </div>
      {summary?.fileName ? (
        <div className="truncate text-xs text-muted-foreground" title={summary.filePath ?? summary.fileName}>
          {summary.fileName}
        </div>
      ) : null}
    </div>
  )
}
